const syncCookieConsent = async () => {
	await fetch('/api/cookie/categories/', {
		method: 'POST',
		credentials: 'include'
	});
};

export default syncCookieConsent;
